import { render, staticRenderFns } from "./NotPaid.vue?vue&type=template&id=6b5c5072&scoped=true&"
import script from "./NotPaid.vue?vue&type=script&lang=js&"
export * from "./NotPaid.vue?vue&type=script&lang=js&"
import style0 from "./NotPaid.vue?vue&type=style&index=0&id=6b5c5072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c5072",
  null
  
)

export default component.exports